export default {
  set(store, payload) {
    store.commit('set', payload);
  },
};
